module.exports = "/_next/static/images/PipeDataIntoWarehouse@3x-c345403aaff7d854a0e5a087668c38c0.webp";